import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export const RulePreviewCollapseIcon = (props) => (<SvgIcon {...props} viewBox="0 0 20 20" fill="none">
    <rect x="0.75" y="18.75" width="18" height="18" rx="3" transform="rotate(-90 0.75 18.75)" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M5.75 18.75V0.75" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </SvgIcon>);
export default RulePreviewCollapseIcon;
